import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  sectionHeader: {
    paddingTop: 30,
    paddingBottom: 15,
  },
  modalSection: {
    paddingBottom: 30,
  },
}));
